import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { PartyService } from '../../_services/_masters/party.service';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Http, Response } from '@angular/http';
import { environment } from '../../../environments/environment';

import { SelectablesService } from '../../selectables.service';

import swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
// import * as $ from 'jquery';
declare var $ : any;

class PartyForm {
	party_name:string;
	address : string;
	branch: string;
	contact_no: string;
}

@Component({
  selector: 'app-party',
  templateUrl: './party.component.html',
  styleUrls: ['./party.component.css']
})
export class PartyComponent implements OnInit {

	partyForm : FormGroup;
	modalPartyForm : FormGroup;
	check_branch: boolean = true;
	modalData : any;

	// Data Table Configurations
	dtOptions: any = {};
	dataTable: any;
	dtTrigger: Subject<any> = new Subject();
	party_form: PartyForm[] = [];

	stations : string[] = [];
	currentUser  : any ;
	token : any ;
	user_role : string = null ;
	user_branch : string = null ;
	url = environment.url;

	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;

	query : any = null;
	response : any = null;
	
	constructor( private partyService : PartyService, 
		private selectBranchService : SelectablesService,
		private http: Http) { }

	ngOnInit() {
		this.partyForm = new FormGroup({
			'party_name': new FormControl(null , Validators.required),
			'address': new FormControl(null , Validators.required),
			'branch': new FormControl(null , Validators.required),
			'contact_no':new FormControl(null , Validators.required)
		});
		
		this.modalPartyForm = new FormGroup({
			'party_name': new FormControl(null , Validators.required),
			'address': new FormControl(null , Validators.required),
			'branch': new FormControl(null , Validators.required),
			'contact_no':new FormControl(null , Validators.required)
		});


		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 5,
			responsive: true,
			// select:true,
			rowCallback: (row: Node, data: any[] | Object, index: number) => {
				const self = this;
				// Unbind first in order to avoid any duplicate handler
				// (see https://github.com/l-lin/angular-datatables/issues/87)
				$('td', row).unbind('click');
				$('td', row).bind('click', () => {
					self.someClickHandler(data);
				});
				return row;
			},
			dom: 'Bfrtip',
			// Configure the buttons
			buttons: [
				// 'columnsToggle',
				'colvis',
				'copy',
				'print',
				'excel'
			]
		};

		this.http.get(this.url + '/masters/party/all')
		// this.http.get('http://backendtransport.iogreen.in/masters/party/all')
			.map(this.extractData)
			.subscribe(forms => {
				this.party_form = forms;
				console.log(this.party_form);
				// Calling the DT trigger to manually render the table
				this.dtTrigger.next();
			});
		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);	
		if(localStorage.getItem('currentUser'))
		{
			if (temp["role"] === 'Admin')
			{
				this.getBranch();
				this.check_branch = false;
			}
			else if(temp['role'] === 'Manager' || temp['role'] === 'Employee')
			{
				this.partyForm.get('branch').setValue(temp['branch']);
				this.check_branch = true;
			}
		}
	}
	getBranch()
    {
     	this.selectBranchService.getBranches()
		.subscribe(
			branches => {
				for(var i=0;i<branches.length;i++)
				{
					this.stations.push(branches[i]['branch_name']);
				}
			});
    }
	private extractData(res: Response) {
		const body = res.json();
		console.log(body.data || {});
		return body;

	};

	someClickHandler(info: any): void {
		this.partyService.getPartyFormWith(info[0])
		.subscribe(response => {
			console.log('aaaaa'+JSON.stringify(response))
			this.modalData = JSON.stringify(response)
			this.modalData =JSON.parse(this.modalData)
			this.modalPartyForm.patchValue({
				"party_name": this.modalData[0].party_name,
				'branch': this.modalData[0].branch,
				"contact_no": this.modalData[0].contact_no,
				"address": this.modalData[0].address
			});
		});	
		$("#default-modal").modal('show');
	};

	submit(){
		console.log(this.partyForm.value);
		//this.partyService.addNewParty(this.partyForm.value)
		//.subscribe(response => console.log(response));

		this.partyService.addNewParty(this.partyForm.value)
		.subscribe(response => 
		{
			
			if(response['status'])
			{
				swal('Save', 'Record save successfully', 'success');
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
				{
					dtInstance.destroy();
					this.http.get(this.url + '/masters/party/all')
						.map(this.extractData)
						.subscribe(forms => 
						{
							this.party_form = forms;
							console.log(this.party_form);
							// Calling the DT trigger to manually render the table
							this.dtTrigger.next();
						});
				});
				
			}
			else
			{
				swal('Oops!', 'Something went wrong on the page!', 'error');
			}
		});
	};

	updateParty(){
		console.log(this.modalPartyForm.value);
		console.log(this.modalData);

		this.query={
			"party_oid" : this.modalData[0]._id,
			"party_data" : this.modalPartyForm.value
		}

		console.log(this.query);

		this.http.post( this.url + "/masters/party/update", this.query)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			console.log(this.response.status);
			if (this.response.status){

				if (this.response.message === 'Party Updated Successfully'){
					swal(
						'Success',
						'Party Form Updated Successfully',
						'success'
					);
					this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
					{
						dtInstance.destroy();
						this.http.get(this.url + '/masters/party/all')
							.map(this.extractData)
							.subscribe(forms => 
							{
								this.party_form = forms;
								console.log(this.party_form);
								// Calling the DT trigger to manually render the table
								this.dtTrigger.next();
							});
					});
				}

				if (this.response.message === 'Party Information not Changed'){
					swal(
						'Info',
						'Party information not changed',
						'info'
					);
				}
			}
			else{
				swal(
					'Unknown Error',
					'Please Refresh your page',
					'error'
				);
			}
			
		});
	};


	// DELETE CONSIGNOR
	deleteParty(){
		console.log("Hello");

		this.query={
			"party_id" : this.modalData[0]._id.$oid,
			"branch": this.modalData[0].branch
		}

		console.log(this.query);

		swal({
			title: 'Are you sure?',
			text: 'You want to delete Party',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'No, keep it'
		}).then((result) => {
			if (result.value) {
			
				this.http.post(this.url + '/masters/party/delete', this.query)
				.map(response => response.json())
				.subscribe(
					(response)=>{
						console.log(response);
						if (response["status"]){
							console.log(response);
							console.log("success");
							swal('Deleted!','Your Party has been deleted.','success');

							this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
							{
								dtInstance.destroy();
								this.http.get(this.url + '/masters/party/all')
									.map(this.extractData)
									.subscribe(forms => 
									{
										this.party_form = forms;
										console.log(this.party_form);
										// Calling the DT trigger to manually render the table
										this.dtTrigger.next();
									});
							});
							
							$("#default-modal").modal("hide");
							
						}else{
							swal("error","Oops , Somthing went wrong, Party is not deleted","error");
						}
					},
					(error)=>console.log(error.json())
					);
			} 
			
		})

	}

	// END

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/masters/party/party.component.ts